module.exports = __webpack_public_path__ + "img/ew-icon_website-builder.403e630b.svg";